import { ComponentType } from 'react';
import { logger } from 'utils/logger';
import { MissingPage } from '@enterprise/common';
import { appVersionUpdates } from 'utils/appVersionUpdates';

export function componentLoader(lazyComponent: any, attemptsLeft = 3) {
  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: Error) => {
        appVersionUpdates.isNewerVersion().then((isNewer) => {
          if (isNewer) {
            window.location.reload();
          }
          return;
        });
        setTimeout(() => {
          if (attemptsLeft === 1) {
            logger.error(error);
            resolve({ default: MissingPage });
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
        }, 500);
      });
  });
}
